import { useBreakpointsContext } from '@air/provider-media-query';

import { useWorkspaceRightPanelOpen } from '~/components/v2/store/features/workspace/useWorkspaceRightPanelOpen';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

/**
 * Determines if the workspace nav should render in push mode instead of inline.
 * Push mode activates when the right panel is open on screens < 1104px (XL),
 * where there isn't enough room for all panels to display inline.
 */
export const useWorkspaceNavPushMode = () => {
  const { isAboveXLScreen } = useBreakpointsContext();
  const { generativeCanvasEnabled } = useTemporaryFeatureFlags();
  const rightPanelOpen = useWorkspaceRightPanelOpen();

  return { isWorkspaceNavPushMode: generativeCanvasEnabled && rightPanelOpen && !isAboveXLScreen };
};
